import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import Dropzone from 'react-dropzone';
import AvatarEditor from 'react-avatar-editor';
import { Button } from 'react-bootstrap';
import { sendData, toDataURL, objectValues, setTextOnly } from '../Utils';
import DraggableText from './DraggableText';
import html2canvas from 'html2canvas';
import { withAlert } from 'react-alert';
class LeftContainer extends Component {
    state = {
        error: '',
        file: '',
        userPerspective: null,
        shouldConfirm: false,
        textInfo: null,
        imageInfo: null,
        key: 0,
    };

    onDrop = (acceptedFiles, rejectedFiles) => {
        if (acceptedFiles.length > 1) {
            this.setState({ error: this.props.intl.messages.onlyOneFile });
        }
        this.setState({ error: '', file: acceptedFiles[0].preview });
    };

    onSubmit = async () => {
        let textInfo = {};
        let imageInfo = {};
        const texts = document.getElementsByClassName('avatar-draggable-text');
        const image = this.avatar;

        if ((!texts || !texts.length) && !image) {
            return;
        }
        if (texts && texts.length) {
            textInfo = Array.from(texts).map(text => {
                const id = text.id;
                const textObj = this.props.texts[id];
                const textDimensions = text.getBoundingClientRect();
                return {
                    text: textObj.text,
                    fontSize: textObj.size,
                    fontColor: textObj.color,
                    fontFamily: textObj.font,
                    fontStyle: textObj.fontWeight,
                    left: textDimensions.left,
                    top: textDimensions.top,
                    width: textDimensions.width,
                    height: textDimensions.height,
                    rotationAngle: textObj.rotation,
                    textAlign: textObj.textAlign,
                };
            });
        }
        if (image) {
            imageInfo = {
                ...imageInfo,
                originalImage: this.state.file ? await toDataURL(this.state.file) : null,
                collageImage: this.avatar ? this.avatar.getImageScaledToCanvas().toDataURL('image/jpeg') : null,
            };
        }

        const textsContents = document.getElementsByClassName('react-avatar-picture-text');

        Array.from(textsContents).forEach(text => {
            text.style.border = 'none';
        });
        const html2 = await html2canvas(document.getElementById('react-avatar-stage'), {
            ignoreElements: e =>
                e.className === 'react-avatar-save-image-btn btn btn-lg btn-success' ||
                e.className === 'react-avatar-left-column-dropzone' ||
                e.className === 'react-avatar-change-image-btn btn btn-lg btn-info',
        });
        const userPerspective = html2.toDataURL('image/jpeg');
        imageInfo.collageImage = userPerspective;
        this.setState({
            userPerspective,
            shouldConfirm: true,
            textInfo,
            imageInfo,
        });

        Array.from(textsContents).forEach(text => {
            text.style.border = '1px dotted red';
        });
    };

    onSuccess = () => {
        const message = this.props.intl.messages.success;
        const root = document.getElementById('root');
        if (root) {
            root.setAttribute('data-submitted', 'true');
        }
        this.props.alert ? this.props.alert.success(message) : alert(message);
    };

    onEdit = () => {
        this.setState({
            shouldConfirm: false,
            userPerspective: null,
            textInfo: null,
            imageInfo: null,
        });
    };

    onContinue = async () => {
        sendData(this.state.textInfo, this.state.imageInfo, this.onSuccess, this.onFailure);
    };

    onChangeImage = () => {
        this.setState({
            file: null,
            shouldConfirm: false,
            key: this.state.key + 1,
        });
    };

    onFailure = e => {
        const message = this.props.intl.messages.error;
        this.props.alert ? this.props.alert.error(message) : alert(message);
    };

    getTexts = () =>
        objectValues(this.props.texts).map(textObj => {
            return (
                <DraggableText
                    key={textObj.id}
                    {...textObj}
                    onChangeText={this.props.onChangeText.bind(this, textObj.id)}
                    selectWidth={this.props.selectWidth.bind(this, textObj.id)}
                    selectHeight={this.props.selectHeight.bind(this, textObj.id)}
                />
            );
        });

    render() {
        const { messages } = this.props.intl;
        const shitBrowser = 'ActiveXObject' in window;
        const maxWidth = window.innerWidth < 1000 ? 230 : 470;
        const maxHeight = window.innerWidth < 1000 ? 220 : 470;
        if (!this.props.frontUrl || !this.props.backgroundUrl) {
            return null;
        }
        return (
            <div className="react-avatar-left-column" id="react-avatar-stage">
                {this.state.shouldConfirm ? (
                    <div className="react-avatar-confirm-wrapper">
                        <img className="react-avatar-confirm-img" src={this.state.userPerspective} />
                        <div className="react-avatar-confirmation-btn-wrapper">
                            <Button
                                data-dismiss="modal"
                                onClick={this.onContinue}
                                bsStyle="success"
                                bsSize="large"
                                className="react-avatar-save-image-btn"
                                style={{ marginRight: '1em' }}
                            >
                                {this.props.intl.messages.confirm}
                            </Button>
                            <Button onClick={this.onEdit} bsStyle="info" bsSize="large" className="react-avatar-save-image-btn">
                                {this.props.intl.messages.edit}
                            </Button>
                        </div>
                    </div>
                ) : (
                    <div id="react-avatar-wrapper" className="react-avatar-left-column-content">
                        <div
                            className="react-avatar-left-background-image-wrapper"
                            style={
                                shitBrowser
                                    ? {
                                          left: '10%',
                                      }
                                    : {}
                            }
                        >
                            <img
                                crossOrigin="credentials"
                                id="react-avatar-edit-image"
                                className="react-avatar-left-background-image"
                                src={this.props.backgroundUrl}
                            />
                            <div className="react-avatar-buttons-wrapper">
                                <Button onClick={this.onSubmit} bsStyle="success" bsSize="large" className="react-avatar-save-image-btn">
                                    {this.props.intl.messages.save}
                                </Button>
                                {this.state.file && (
                                    <Button onClick={this.onChangeImage} bsStyle="info" bsSize="large" className="react-avatar-change-image-btn">
                                        {this.props.intl.messages.changeImage}
                                    </Button>
                                )}
                            </div>
                        </div>
                        <img
                            className="react-avatar-left-foreground-image"
                            src={this.props.frontUrl}
                            style={
                                shitBrowser
                                    ? {
                                          left: '10%',
                                      }
                                    : {}
                            }
                        />
                        <div
                            style={
                                shitBrowser
                                    ? {
                                          width: maxWidth,
                                          height: maxHeight,
                                          zIndex: 2,
                                          left: '12%',
                                      }
                                    : {
                                          width: maxWidth,
                                          height: maxHeight,
                                          zIndex: 2,
                                      }
                            }
                            id="react-avatar-uploaded-image"
                            className="react-avatar-image"
                            key={this.state.key}
                        >
                            <AvatarEditor
                                ref={avatar => (this.avatar = avatar)}
                                image={this.state.file}
                                width={500}
                                height={500}
                                border={this.props.vignette}
                                color={[255, 255, 255, 0]}
                                scale={this.props.zoom}
                                rotate={this.props.rotation}
                                style={{
                                    maxWidth,
                                    maxHeight,
                                    zIndex: 2,
                                    marginBottom: '-25px',
                                }}
                            />
                        </div>
                        <div
                            id="react-avatar-whitezone"
                            className="react-avatar-image"
                            style={
                                shitBrowser
                                    ? {
                                          pointerEvents: this.state.file ? 'none' : 'auto',
                                          left: '10%',
                                      }
                                    : {
                                          pointerEvents: this.state.file ? 'none' : 'auto',
                                      }
                            }
                        >
                            {!this.state.file && (
                                <Dropzone className="react-avatar-left-column-dropzone" style={{ display: setTextOnly()=='1'?'none':'flex'}} onDrop={this.onDrop}>
                                    <p className="react-avatar-left-column-drop-text">{messages.dragOrClick}</p>
                                </Dropzone>
                            )}
                            {this.getTexts()}
                        </div>
                        <p className="react-avatar-left-column-error">{this.state.error}</p>
                    </div>
                )}
            </div>
        );
    }
}

export default withAlert(injectIntl(LeftContainer));



// WEBPACK FOOTER //
// ./src/Components/LeftContainer.js